





























































































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {BlacklistGeneralItem} from "@/store/settings/blacklists/types";
import ImportGenerals from "@/components/Settings/BlackLists/ImportGenerals.vue";
import BlackListGeneralsFilter from "@/components/Settings/BlackLists/BlackListGeneralsFilter.vue";
import {notifyDelete, notifyError} from "@/utils/notify-helper";
import BlackListContactsFilter from "@/components/Settings/BlackLists/BlackListContactsFilter.vue";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {BlackListContactsFilter, BlackListGeneralsFilter, ImportGenerals, ScrollButton}})
export default class BlackListGenerals extends BaseItemsPage<BlacklistGeneralItem> {
  @Getter("blacklistGenerals") blacklistGenerals: any;
  @Action("deleteBlackListGenerals") actionDelete: any;
  @Action("actionLog") actionLog: any;

  private is_show_import = false;
  private is_show_filter = false;
  private recipientIds: (number | undefined)[] = [];
  private logObject: ActionLog = {};
  currentSort = "id";
  currentSortOrder = "desc";
  tableFields = ['msisdn', 'email', 'description',];

  getData(): any {
    return this.blacklistGenerals;
  }

  async onDeleteItem(): Promise<void> {
    let isConfirm: boolean = await notifyDelete();
    if (isConfirm) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Contact",
          addititional_info: getTranslatedParams({id: this.$route.params.id, number: this.recipientIds.length})
        }
        const item = {
          id: this.recipientIds,
          recipientIds: this.recipientIds
        }
        await this.actionDelete(item);
        await this.actionLog(this.logObject);
      } catch (error) {
        this.actionLog({...this.logObject, action_status: 'failed'});
        notifyError(error);
      }
    }
  }

  onSelect(items: BlacklistGeneralItem[]): void {
    this.recipientIds = items.filter(i => i.id).map(i => i.id)
  }
}
